module.exports = __webpack_public_path__ + "img/30.d209b968.png";